const ShareCardLogo = () => (
    <svg
        width='153'
        height='41'
        viewBox='0 0 153 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='share-card-logo'
    >
        <path
            d='M18.768 40.6476L25.1087 37.2076C25.3113 37.0979 25.4805 36.9355 25.5984 36.7375C25.7163 36.5396 25.7784 36.3134 25.7783 36.083V1.10798C25.7785 0.971544 25.7422 0.837538 25.6733 0.719789C25.6044 0.60204 25.5053 0.504812 25.3863 0.438136C25.2672 0.371459 25.1326 0.337749 24.9962 0.340486C24.8598 0.343224 24.7266 0.382312 24.6103 0.453711L18.2466 4.34096C18.0598 4.45528 17.9055 4.61568 17.7985 4.80678C17.6916 4.99788 17.6355 5.21326 17.6357 5.43225V39.9754C17.6361 40.1081 17.6709 40.2384 17.7366 40.3537C17.8024 40.4689 17.897 40.5651 18.0111 40.6328C18.1252 40.7006 18.2549 40.7375 18.3875 40.7401C18.5202 40.7427 18.6513 40.7108 18.768 40.6476Z'
            fill='url(#share-share-paint0_linear_3859_642)'
        />
        <path
            d='M14.3232 31.2524V38.9196C14.3231 39.0093 14.2995 39.0973 14.2546 39.175C14.2097 39.2526 14.1452 39.3171 14.0675 39.3619C13.9898 39.4067 13.9016 39.4302 13.812 39.4302C13.7223 39.4302 13.6342 39.4066 13.5565 39.3617L9.19139 36.8188L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19185 26.5074 9.31015 26.9475 9.53444 27.3356C9.75873 27.7236 10.0811 28.0458 10.4692 28.2699L13.6971 30.1484C13.8886 30.2619 14.0471 30.4235 14.157 30.6171C14.2668 30.8108 14.3241 31.0298 14.3232 31.2524Z'
            fill='url(#share-paint1_linear_3859_642)'
        />
        <path
            d='M13.5565 39.3541L9.19139 36.8111L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19139 26.0592 8.68531 31.2218 13.5565 39.3541Z'
            fill='url(#share-paint2_radial_3859_642)'
        />
        <path
            d='M18.768 40.6476L25.1087 37.2076C25.3113 37.0979 25.4805 36.9355 25.5984 36.7375C25.7163 36.5396 25.7784 36.3134 25.7783 36.083V1.10798C25.7785 0.971544 25.7422 0.837538 25.6733 0.719789C25.6044 0.60204 25.5053 0.504812 25.3863 0.438136C25.2672 0.371459 25.1326 0.337749 24.9962 0.340486C24.8598 0.343224 24.7266 0.382312 24.6103 0.453711L18.2466 4.34096C18.0598 4.45528 17.9055 4.61568 17.7985 4.80678C17.6916 4.99788 17.6355 5.21326 17.6357 5.43225V39.9754C17.6361 40.1081 17.6709 40.2384 17.7366 40.3537C17.8024 40.4689 17.897 40.5651 18.0111 40.6328C18.1252 40.7006 18.2549 40.7375 18.3875 40.7401C18.5202 40.7427 18.6513 40.7108 18.768 40.6476Z'
            fill='url(#share-paint3_linear_3859_642)'
        />
        <path
            d='M14.3232 31.2524V38.9196C14.3231 39.0093 14.2995 39.0973 14.2546 39.175C14.2097 39.2526 14.1452 39.3171 14.0675 39.3619C13.9898 39.4067 13.9016 39.4302 13.812 39.4302C13.7223 39.4302 13.6342 39.4066 13.5565 39.3617L9.19139 36.8188L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19185 26.5074 9.31015 26.9475 9.53444 27.3356C9.75873 27.7236 10.0811 28.0458 10.4692 28.2699L13.6971 30.1484C13.8886 30.2619 14.0471 30.4235 14.157 30.6171C14.2668 30.8108 14.3241 31.0298 14.3232 31.2524Z'
            fill='url(#share-paint4_linear_3859_642)'
        />
        <path
            d='M13.5565 39.3541L9.19139 36.8111L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19139 26.0592 8.68531 31.2218 13.5565 39.3541Z'
            fill='url(#share-paint5_radial_3859_642)'
        />
        <path
            opacity='0.3'
            d='M18.4023 40.8696C18.1651 40.8696 17.9376 40.7753 17.7698 40.6076C17.6021 40.4398 17.5078 40.2123 17.5078 39.9751V5.43192C17.5084 5.19106 17.5705 4.95434 17.6881 4.74414C17.8058 4.53395 17.975 4.35725 18.18 4.23073L24.5437 0.343471C24.6844 0.259371 24.845 0.214378 25.0089 0.213135C25.2464 0.213134 25.4742 0.307291 25.6423 0.47497C25.8105 0.642649 25.9053 0.870166 25.9059 1.10764V36.0827C25.9056 36.336 25.837 36.5845 25.7075 36.8021C25.578 37.0198 25.3923 37.1985 25.1699 37.3197L18.8292 40.7597C18.6987 40.8323 18.5516 40.8701 18.4023 40.8696Z'
            fill='url(#share-paint6_linear_3859_642)'
        />
        <path
            d='M18.768 40.6476L25.1087 37.2076C25.3113 37.0979 25.4805 36.9355 25.5984 36.7375C25.7163 36.5396 25.7784 36.3134 25.7783 36.083V1.10798C25.7785 0.971544 25.7422 0.837538 25.6733 0.719789C25.6044 0.60204 25.5053 0.504812 25.3863 0.438136C25.2672 0.371459 25.1326 0.337749 24.9962 0.340486C24.8598 0.343224 24.7266 0.382312 24.6103 0.453711L18.2466 4.34096C18.0598 4.45528 17.9055 4.61568 17.7985 4.80678C17.6916 4.99788 17.6355 5.21326 17.6357 5.43225V39.9754C17.6361 40.1081 17.6709 40.2384 17.7366 40.3537C17.8024 40.4689 17.897 40.5651 18.0111 40.6328C18.1252 40.7006 18.2549 40.7375 18.3875 40.7401C18.5202 40.7427 18.6513 40.7108 18.768 40.6476Z'
            fill='url(#share-paint7_linear_3859_642)'
        />
        <path
            opacity='0.3'
            d='M13.8118 39.5611C13.6996 39.5605 13.5894 39.5305 13.4923 39.4742L2.24717 32.9315C1.84184 32.6946 1.5055 32.3557 1.27149 31.9487C1.03748 31.5416 0.913927 31.0805 0.913087 30.611V14.3054C0.912807 14.0524 0.981092 13.804 1.11069 13.5866C1.2403 13.3693 1.4264 13.1911 1.64917 13.071L7.98987 9.62847C8.12609 9.55365 8.27949 9.51572 8.43487 9.51845C8.59026 9.52117 8.74225 9.56445 8.87576 9.64399C9.00927 9.72353 9.11972 9.83657 9.1961 9.97192C9.27247 10.1073 9.31215 10.2602 9.31122 10.4156V26.0592C9.31198 26.4838 9.4237 26.9007 9.6353 27.2688C9.8469 27.6368 10.151 27.9432 10.5175 28.1575L13.7454 30.0385C13.9576 30.1622 14.1337 30.3394 14.2561 30.5524C14.3785 30.7654 14.443 31.0068 14.4431 31.2524V38.9196C14.4438 39.0882 14.3778 39.2502 14.2596 39.3704C14.1413 39.4905 13.9804 39.5591 13.8118 39.5611Z'
            fill='url(#share-paint8_linear_3859_642)'
        />
        <path
            d='M14.3232 31.2524V38.9196C14.3231 39.0093 14.2995 39.0973 14.2546 39.175C14.2097 39.2526 14.1452 39.3171 14.0675 39.3619C13.9898 39.4067 13.9016 39.4302 13.812 39.4302C13.7223 39.4302 13.6342 39.4066 13.5565 39.3617L9.19139 36.8188L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19185 26.5074 9.31015 26.9475 9.53444 27.3356C9.75873 27.7236 10.0811 28.0458 10.4692 28.2699L13.6971 30.1484C13.8886 30.2619 14.0471 30.4235 14.157 30.6171C14.2668 30.8108 14.3241 31.0298 14.3232 31.2524Z'
            fill='url(#share-paint9_linear_3859_642)'
        />
        <path
            d='M13.5565 39.3541L9.19139 36.8111L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19139 26.0592 8.68531 31.2218 13.5565 39.3541Z'
            fill='url(#share-paint10_radial_3859_642)'
        />
        <path
            opacity='0.3'
            d='M18.4023 40.8696C18.1651 40.8696 17.9376 40.7753 17.7698 40.6076C17.6021 40.4398 17.5078 40.2123 17.5078 39.9751V5.43192C17.5084 5.19106 17.5705 4.95434 17.6881 4.74414C17.8058 4.53395 17.975 4.35725 18.18 4.23073L24.5437 0.343471C24.6844 0.259371 24.845 0.214378 25.0089 0.213135C25.2464 0.213134 25.4742 0.307291 25.6423 0.47497C25.8105 0.642649 25.9053 0.870166 25.9059 1.10764V36.0827C25.9056 36.336 25.837 36.5845 25.7075 36.8021C25.578 37.0198 25.3923 37.1985 25.1699 37.3197L18.8292 40.7597C18.6987 40.8323 18.5516 40.8701 18.4023 40.8696Z'
            fill='url(#share-paint11_linear_3859_642)'
        />
        <path
            d='M18.768 40.6476L25.1087 37.2076C25.3113 37.0979 25.4805 36.9355 25.5984 36.7375C25.7163 36.5396 25.7784 36.3134 25.7783 36.083V1.10798C25.7785 0.971544 25.7422 0.837538 25.6733 0.719789C25.6044 0.60204 25.5053 0.504812 25.3863 0.438136C25.2672 0.371459 25.1326 0.337749 24.9962 0.340486C24.8598 0.343224 24.7266 0.382312 24.6103 0.453711L18.2466 4.34096C18.0598 4.45528 17.9055 4.61568 17.7985 4.80678C17.6916 4.99788 17.6355 5.21326 17.6357 5.43225V39.9754C17.6361 40.1081 17.6709 40.2384 17.7366 40.3537C17.8024 40.4689 17.897 40.5651 18.0111 40.6328C18.1252 40.7006 18.2549 40.7375 18.3875 40.7401C18.5202 40.7427 18.6513 40.7108 18.768 40.6476Z'
            fill='url(#share-paint12_linear_3859_642)'
        />
        <path
            d='M14.3232 31.2524V38.9196C14.3231 39.0093 14.2995 39.0973 14.2546 39.175C14.2097 39.2526 14.1452 39.3171 14.0675 39.3619C13.9898 39.4067 13.9016 39.4302 13.812 39.4302C13.7223 39.4302 13.6342 39.4066 13.5565 39.3617L9.19139 36.8188L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19185 26.5074 9.31015 26.9475 9.53444 27.3356C9.75873 27.7236 10.0811 28.0458 10.4692 28.2699L13.6971 30.1484C13.8886 30.2619 14.0471 30.4235 14.157 30.6171C14.2668 30.8108 14.3241 31.0298 14.3232 31.2524Z'
            fill='url(#share-paint13_linear_3859_642)'
        />
        <path
            opacity='0.3'
            d='M9.3195 26.0592C9.3195 26.1231 8.87736 31.2933 13.6642 39.2876C13.6791 39.312 13.6852 39.3408 13.6815 39.3692C13.6778 39.3975 13.6645 39.4238 13.6438 39.4435C13.62 39.4674 13.5879 39.4811 13.5543 39.4819C13.5319 39.4811 13.51 39.4749 13.4904 39.464L2.24521 32.9213C1.83989 32.6843 1.50355 32.3455 1.26953 31.9385C1.03552 31.5314 0.911974 31.0703 0.911134 30.6007V14.3054C0.910854 14.0524 0.979139 13.804 1.10874 13.5866C1.23834 13.3693 1.42445 13.1911 1.64721 13.071L7.98792 9.62847C8.12413 9.55365 8.27753 9.51572 8.43292 9.51845C8.58831 9.52117 8.74029 9.56445 8.87381 9.64399C9.00732 9.72353 9.11777 9.83657 9.19415 9.97192C9.27052 10.1073 9.3102 10.2602 9.30927 10.4156'
            fill='url(#share-paint14_linear_3859_642)'
        />
        <path
            d='M13.5565 39.3541L9.19139 36.8111L2.32669 32.8089C1.93893 32.585 1.61677 32.2632 1.3925 31.8756C1.16824 31.4881 1.04974 31.0485 1.04883 30.6007V14.3054C1.04916 14.0755 1.11155 13.8499 1.2294 13.6524C1.34725 13.4549 1.51622 13.2929 1.71846 13.1835L8.05916 9.74091C8.176 9.67755 8.30733 9.64566 8.44021 9.64835C8.57309 9.65105 8.70297 9.68824 8.81714 9.75628C8.93131 9.82432 9.02583 9.92087 9.09143 10.0365C9.15703 10.152 9.19151 10.2827 9.19139 10.4156V26.0592C9.19139 26.0592 8.68531 31.2218 13.5565 39.3541Z'
            fill='url(#share-paint15_radial_3859_642)'
        />
        <path
            d='M45.2635 5.31445V14.6709C45.2635 15.6932 45.519 16.4753 46.0634 17.0222C46.6078 17.5691 47.3413 17.8349 48.315 17.8349C49.2888 17.8349 50.0555 17.5794 50.5897 17.0222C51.1238 16.4651 51.3896 15.7009 51.3896 14.6709V5.31445H54.4411V14.6684C54.4769 15.8146 54.1862 16.9473 53.6028 17.9346C53.0641 18.8047 52.2872 19.5019 51.364 19.9434C50.3904 20.3994 49.3262 20.6291 48.2511 20.6156C47.1908 20.6301 46.1413 20.4001 45.1843 19.9434C44.2779 19.5026 43.5221 18.8037 43.0119 17.9346C42.4494 16.9403 42.1718 15.8102 42.2094 14.6684V5.31445H45.2635Z'
            fill='white'
        />
        <path
            d='M70.3097 20.452H67.271L60.4063 10.0783V20.452H57.3701V5.29907H60.4063L67.271 15.6983V5.29907H70.3097V20.452Z'
            fill='white'
        />
        <path
            d='M76.3331 18.0496H81.3168V20.452H73.2969V5.31445H76.3331V18.0394V18.0496Z'
            fill='white'
        />
        <path d='M86.2734 5.31445V20.4418H83.25V5.31445H86.2734Z' fill='white' />
        <path
            d='M105.76 5.31445V20.4418H102.721V10.6022L98.678 20.452H96.3779L92.2887 10.6125V20.452H89.25V5.31445H92.6951L97.4998 16.5596L102.305 5.31445H105.76Z'
            fill='white'
        />
        <path d='M111.784 5.31445V20.4418H108.745V5.31445H111.784Z' fill='white' />
        <path
            d='M125.053 5.31445V7.76795H121.026V20.4418H117.987V7.77817H113.959V5.31445H125.053Z'
            fill='white'
        />
        <path
            d='M130.303 7.77813V11.5657H135.414V13.9681H130.303V17.9729H136.048V20.4392H127.279V5.29907H136.048V7.76534H130.303V7.77813Z'
            fill='white'
        />
        <path
            d='M148.276 6.25239C149.45 6.84239 150.423 7.76736 151.072 8.91034C151.723 10.1375 152.063 11.5055 152.063 12.8947C152.063 14.2839 151.723 15.6519 151.072 16.8791C150.414 18.0088 149.443 18.9232 148.276 19.5115C146.973 20.1527 145.534 20.4709 144.082 20.4392H138.802V5.31444H144.09C145.539 5.29352 146.974 5.61487 148.276 6.25239ZM147.652 16.5749C148.516 15.7111 148.948 14.4903 148.948 12.9126C148.948 11.3349 148.516 10.1022 147.652 9.21447C146.788 8.32508 145.557 7.88038 143.967 7.88038H141.818V17.8707H143.967C145.557 17.8707 146.788 17.4388 147.652 16.5749Z'
            fill='white'
        />
        <path
            d='M43.2191 34.7896H46.769V35.5921H42.2275V25.7117H43.2191V34.7896Z'
            fill='white'
        />
        <path
            d='M55.8617 26.5269V30.2149H59.6135V31.0429H55.8617V34.7922H60.0327V35.6202H54.8701V25.7117H60.0327V26.5269H55.8617Z'
            fill='white'
        />
        <path
            d='M76.7778 25.7117L73.0285 35.6049H71.8963L68.1445 25.7117H69.2256L72.4688 34.5238L75.735 25.7117H76.7778Z'
            fill='white'
        />
        <path
            d='M85.8711 26.5269V30.2149H89.6204V31.0429H85.8711V34.7922H90.0421V35.6202H84.877V25.7117H90.0395V26.5269H85.8685H85.8711Z'
            fill='white'
        />
        <path
            d='M103.406 35.6049L100.963 31.4723H99.1333V35.6049H98.1416V25.7117H101.116C102.223 25.7117 103.061 25.9672 103.621 26.4988C103.905 26.7649 104.127 27.0888 104.274 27.4487C104.421 27.8086 104.489 28.1959 104.472 28.5843C104.489 29.2474 104.274 29.8955 103.864 30.4168C103.396 30.9531 102.749 31.301 102.044 31.3956L104.587 35.5921H103.406V35.6049ZM99.1333 30.6698H101.129C101.896 30.6698 102.489 30.4806 102.872 30.0973C103.243 29.6844 103.45 29.1504 103.455 28.5955C103.459 28.0407 103.261 27.5032 102.898 27.0841C102.514 26.7288 101.929 26.5499 101.109 26.5499H99.1256V30.6698H99.1333Z'
            fill='white'
        />
        <path
            d='M119.108 33.2507H114.608L113.741 35.6045H112.701L116.312 25.8391H117.429L121.028 35.6045H119.985L119.108 33.2507ZM118.817 32.438L116.857 27.0837L114.899 32.438H118.817Z'
            fill='white'
        />
        <path
            d='M137.356 28.5972C137.086 27.9681 136.634 27.4341 136.058 27.0638C135.445 26.6841 134.735 26.4898 134.013 26.5041C133.318 26.4923 132.633 26.669 132.03 27.0152C131.444 27.3629 130.965 27.8651 130.645 28.4669C130.31 29.1471 130.136 29.8951 130.136 30.6533C130.136 31.4114 130.31 32.1594 130.645 32.8397C130.96 33.4475 131.44 33.9542 132.03 34.3016C132.633 34.6487 133.318 34.8253 134.013 34.8127C134.66 34.8218 135.299 34.6689 135.871 34.368C136.421 34.0674 136.881 33.6265 137.205 33.0902C137.548 32.5002 137.744 31.8368 137.778 31.1555H133.62V30.3607H138.821V31.0865C138.784 31.9176 138.539 32.7262 138.108 33.4377C137.684 34.1452 137.081 34.7283 136.36 35.1281C135.639 35.5279 134.825 35.7304 134.001 35.7149C133.127 35.7246 132.267 35.5004 131.509 35.0657C130.767 34.6414 130.156 34.0228 129.74 33.2767C129.316 32.4734 129.094 31.5785 129.094 30.6699C129.094 29.7613 129.316 28.8664 129.74 28.0631C130.153 27.3146 130.765 26.6952 131.509 26.2741C132.319 25.8254 133.235 25.6019 134.16 25.6266C135.086 25.6513 135.988 25.9234 136.774 26.4146C137.571 26.9483 138.176 27.723 138.501 28.6253H137.359L137.356 28.5972Z'
            fill='white'
        />
        <path
            d='M147.921 26.5269V30.2149H151.673V31.0429H147.921V34.7922H152.092V35.6202H146.93V25.7117H152.092V26.5269H147.921Z'
            fill='white'
        />
        <defs>
            <linearGradient
                id='share-paint0_linear_3859_642'
                x1='21.8297'
                y1='46.9142'
                x2='21.6022'
                y2='-1.69054'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint1_linear_3859_642'
                x1='4.45049'
                y1='24.6995'
                x2='20.6614'
                y2='24.2983'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='share-paint2_radial_3859_642'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(7.30267 24.5002) scale(16.8933 16.8933)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='share-paint3_linear_3859_642'
                x1='21.8297'
                y1='46.9142'
                x2='21.6022'
                y2='-1.69054'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint4_linear_3859_642'
                x1='4.45049'
                y1='24.6995'
                x2='20.6614'
                y2='24.2983'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='share-paint5_radial_3859_642'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(7.30267 24.5002) scale(16.8933 16.8933)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='share-paint6_linear_3859_642'
                x1='21.8296'
                y1='47.08'
                x2='21.6021'
                y2='-1.83144'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint7_linear_3859_642'
                x1='21.8297'
                y1='46.9142'
                x2='21.6022'
                y2='-1.69054'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint8_linear_3859_642'
                x1='4.38887'
                y1='24.7021'
                x2='20.9141'
                y2='24.2932'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint9_linear_3859_642'
                x1='4.45049'
                y1='24.6995'
                x2='20.6614'
                y2='24.2983'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='share-paint10_radial_3859_642'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(7.30267 24.5002) scale(16.8933 16.8933)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='share-paint11_linear_3859_642'
                x1='21.8296'
                y1='47.08'
                x2='21.6021'
                y2='-1.83144'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint12_linear_3859_642'
                x1='21.8297'
                y1='46.9142'
                x2='21.6022'
                y2='-1.69054'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint13_linear_3859_642'
                x1='4.45049'
                y1='24.6995'
                x2='20.6614'
                y2='24.2983'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='share-paint14_linear_3859_642'
                x1='7.38224'
                y1='42.1807'
                x2='6.98866'
                y2='6.37758'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='share-paint15_radial_3859_642'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(11.1823 24.398) scale(16.8933 16.8933)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
        </defs>
    </svg>
);

export default ShareCardLogo;
